var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.25,
    height: 37.25,
    viewBox: "0 0 37.25 37.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "document",
    d: "M33.5,39.083H7.421A5.588,5.588,0,0,1,1.833,33.5V3.7A1.863,1.863,0,0,1,3.7,1.833H29.771A1.863,1.863,0,0,1,31.633,3.7v22.35h7.45V33.5A5.588,5.588,0,0,1,33.5,39.083Zm-1.863-9.312V33.5a1.863,1.863,0,0,0,3.725,0V29.771Zm-3.725,5.587V5.558H5.558V33.5a1.863,1.863,0,0,0,1.862,1.863ZM9.283,11.146h14.9v3.725H9.283Zm0,7.45h14.9v3.725H9.283Zm0,7.45H18.6v3.725H9.283Z",
    transform: "translate(-1.833 -1.833)",
    fill: "#ff6624"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.0359823ca09ff5b5dc13ba37f561ce46.svg";
export { ForwardRef as ReactComponent };